// extracted by mini-css-extract-plugin
export default {"messages":"Messages_messages__Leksd","empty":"Messages_empty__8D-uN"};